import { useRef, useState, useEffect, useMemo } from "react";

import { useLibraryDocumentViewer } from "../../context/LibraryDocumentViewerContext";

import { LibraryViewCard } from "./library-view-card";
import HeaderSectionLibraryDocuments from "./header-section-library-documents";

const CARD_MIN_WIDTH = 255;
const GAP = 5;

const LibraryDocumentTab = ({ data, refetchData }) => {
  const containerRef = useRef(null);
  const [cardsPerRow, setCardsPerRow] = useState(1);
  const [cardWidth, setCardWidth] = useState(CARD_MIN_WIDTH);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const updateLayout = () => {
      const containerWidth = el.getBoundingClientRect().width;
      const perRow = Math.floor((containerWidth + GAP) / (CARD_MIN_WIDTH + GAP)) || 1;
      const availableWidth = containerWidth - (perRow - 1) * GAP;

      setCardsPerRow(perRow);
      setCardWidth(availableWidth / perRow);
    };

    const observer = new ResizeObserver(updateLayout);
    observer.observe(el);
    updateLayout();

    return () => observer.disconnect();
  }, []);

  const rows = useMemo(() => {
    const docs = data?.data ?? [];
    const chunked = [];
    for (let i = 0; i < docs.length; i += cardsPerRow) {
      chunked.push(docs.slice(i, i + cardsPerRow));
    }
    return chunked;
  }, [cardsPerRow, data]);
  const { openDocument } = useLibraryDocumentViewer();
  const handleDocPreview = (d) => {
    openDocument(d, { onUpdated: refetchData });
  };

  const fullRowWidth = cardWidth * cardsPerRow + GAP * (cardsPerRow - 1);

  return (
    <div ref={containerRef} style={{ width: "100%" }}>
      {rows.map((rowDocs, rowIndex) => (
        <div key={rowIndex} style={{ marginBottom: GAP }}>
          <HeaderSectionLibraryDocuments
            name="Library"
            iconClass="ic-library"
            width={fullRowWidth}
          />

          <div style={{ display: "flex", gap: GAP }}>
            {rowDocs.map((doc, docIndex) => (
              <LibraryViewCard
                key={doc.id}
                doc={doc}
                handleDocPreview={handleDocPreview}
                cardWidth={cardWidth}
                rowIndex={rowIndex}
                cardPositionInRow={docIndex}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default LibraryDocumentTab;
